<template>
  <div>
    <nav class="breadcrumb" aria-label="breadcrumbs">
      <ul>
        <li><router-link to="/clients">Applications</router-link></li>
        <li><router-link v-bind:to="`/clients/${this.$route.params.client_id}`">{{ this.$store.state.client.name }}</router-link></li>
        <li class="is-active"><a href="#" aria-current="page">Devices</a></li>
      </ul>
    </nav>

    <nav class="level">
      <div class="level-left"></div>
      <div class="level-right">
        <div class="level-item">
          <p>Total: <strong>{{ this.$store.state.clientDevicesTotal | numberDisplay }}</strong> devices</p>
        </div>

        <div class="level-item">
          <div class="field is-horizontal">
            <div class="field-body">
              <div class="field">
                <div class="control has-icons-left">
                  <datepicker v-model="createdAfter"></datepicker>
                  <span class="icon is-small is-left"><i class="fa fa-calendar"></i></span>
                </div>
              </div>

              <div class="field">
                <div class="control has-icons-left">
                  <datepicker v-model="createdBefore"></datepicker>
                  <span class="icon is-small is-left"><i class="fa fa-calendar"></i></span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="level-item">
          <div class="field has-addons">
            <div class="control">
              <input v-model="searchValue" class="input" type="text" placeholder="Find by" v-on:keyup.enter="searchDevices">
            </div>
            <div class="control">
              <span class="select">
                <select v-model="searchKey">
                  <option value="manufacturer">Manufacturer</option>
                  <option value="model">Model</option>
                  <option value="platform">Platform</option>
                  <option value="platform_ver">Platform version</option>
                </select>
              </span>
            </div>
            <div class="control">
              <button class="button is-primary" v-on:click="searchDevices">Search</button>
            </div>
          </div>
        </div>
      </div>
    </nav>

    <pagination
      v-bind:urlBuilder="buildPaginatorUrls"
      v-bind:currentPage="currentPage"
      v-bind:lastPage="lastPage"
      v-bind:displayPage="5"
      class="is-small" />

    <table class="table is-striped is-fullwidth">
      <thead>
        <tr>
          <th>ID</th>
          <th>Manufacturer</th>
          <th>Model</th>
          <th>Platform</th>
          <th>Platform version</th>
          <th>Created at</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="!this.$store.state.clientDevices.length">
          <td colspan="6" class="has-text-centered has-text-grey">No devices found</td>
        </tr>
        <tr v-for="item in this.$store.state.clientDevices">
          <td>{{ item.id }}</td>
          <td>{{ item.manufacturer }}</td>
          <td>{{ item.model }}</td>
          <td>{{ item.platform }}</td>
          <td>{{ item.platform_ver }}</td>
          <td>{{ item.created_at }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import Pagination from 'vue-bulma-pagination'
  import Datepicker from 'vue-bulma-datepicker'

  export default {
    data () {
      return {
        createdAfter: this.$route.query.created_after || '',
        createdBefore: this.$route.query.created_before || '',
        searchValue: this.$route.query.manufacturer ||
          this.$route.query.model ||
          this.$route.query.platform ||
          this.$route.query.platform_ver ||
          '',
        searchKey: this.$route.query.manufacturer ? 'manufacturer'
          : this.$route.query.model ? 'model'
          : this.$route.query.platform ? 'platform'
          : this.$route.query.platform_ver ? 'platform_ver'
          : 'manufacturer',

        searchParams: {}
      }
    },

    computed: {
      currentPage () {
        return parseInt(this.$route.query.page) || 1
      },

      lastPage () {
        return Math.ceil(this.$store.state.clientDevicesTotal / 20)
      }
    },

    methods: {
      buildPaginatorUrls (page) {
        return { query: { ...this.$route.query, page } }
      },

      searchDevices () {
        this.searchParams[this.searchKey] = this.searchValue
        this.searchParams.created_after = this.createdAfter
        this.searchParams.created_before = this.createdBefore

        // Clean empty fields
        Object.keys(this.searchParams)
          .filter(key => !this.searchParams[key])
          .forEach(key => delete this.searchParams[key])

        this.$router.push({
          path: `/clients/${this.$route.params.client_id}/devices`,
          query: this.searchParams
        })
      }
    },

    created () {
      this.$store.dispatch('getClient', {
        clientId: this.$route.params.client_id
      })

      this.$store.dispatch('getClientDevices', {
        clientId: this.$route.params.client_id,
        params: this.$route.query
      })
    },

    watch: {
      '$route.query' (query) {
        this.$store.dispatch('getClientDevices', {
          clientId: this.$route.params.client_id,
          params: this.$route.query
        })
      },

      // Delete old search parameter
      // to prevent sending two parameters at the same time
      // because the form visually doesn't support this case
      searchKey (newSearchKey, oldSearchKey) {
        delete this.searchParams[oldSearchKey]
      }
    },

    components: {
      Pagination,
      Datepicker
    }
  }
</script>



// WEBPACK FOOTER //
// DeviceList.vue?82875c04